import { FaPhoneAlt } from "react-icons/fa";

function notificationLabel(message) {
  const normalizedMessage = String(message || "");

  if (/followup/i.test(normalizedMessage)) {
    return "Follow up call due in 5 min";
  }

  if (/urgent/i.test(normalizedMessage)) {
    return "Urgent contact assigned to you";
  }

  return normalizedMessage;
}

function TelecallingNotificationAlert({
  notification,
  isAcknowledging,
  acknowledgeError,
  onAcknowledge,
}) {
  if (!notification) {
    return null;
  }

  const phone = notification.notif_phone || notification.phone;
  const label = notificationLabel(notification.message);

  return (
    <section
      aria-live="polite"
      className="mt-6 flex items-center justify-between gap-5 rounded-md border border-[#ffe08a] bg-[#fff3cd] px-4 py-4 text-[#664d03] shadow-sm max-[720px]:flex-col max-[720px]:items-stretch"
      role="alert"
    >
      <div className="min-w-0">
        <p className="m-0 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-base">
          <FaPhoneAlt
            aria-hidden="true"
            className="mr-1 h-4 w-4 flex-none rotate-[-18deg] text-[#d63384]"
          />
          <strong>{label}</strong>
          {notification.name && <span>{notification.name}</span>}
          {phone && <span>({phone})</span>}
        </p>
        <p className="mb-0 mt-1 text-sm">
          Please acknowledge once you have reviewed.
        </p>
        {acknowledgeError && (
          <p className="mb-0 mt-2 text-sm font-semibold text-[#842029]">
            {acknowledgeError}
          </p>
        )}
      </div>

      <button
        className="inline-flex h-[38px] shrink-0 items-center justify-center rounded-md border border-[#664d03] bg-transparent px-4 text-sm font-medium text-[#332701] transition hover:bg-[#ffe69c] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#b68a00] disabled:cursor-not-allowed disabled:opacity-60 max-[720px]:w-full"
        disabled={isAcknowledging}
        type="button"
        onClick={onAcknowledge}
      >
        {isAcknowledging ? "Acknowledging..." : "Acknowledge"}
      </button>
    </section>
  );
}

export default TelecallingNotificationAlert;
